import { USER_LOADING, TOKEN } from './types';

const initialState = {
  isLoggedIn: !!localStorage.getItem('isLogged'),
  refreshToken: localStorage.getItem('refreshToken'),
  expiresIn: localStorage.getItem('expiresIn'),
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case USER_LOADING:
      localStorage.setItem('isLogged', true);
      return { ...state, isLoggedIn: payload };
    case TOKEN:
      localStorage.setItem('refreshToken', payload.payload.refresh_token);
      localStorage.setItem('expiresIn', payload.payload.expires_in);
      return {
        ...state,
        refreshToken: payload.payload.refresh_token,
        expiresIn: payload.payload.expires_in,
      };
    default:
      return state;
  }
};
